import { Action } from 'redux';

import { portalTypeSelector } from '../app/selectors/portal-type.selector';
import { Address } from '../domain/address';
import { updateBusinessAddress, updateShippingAddress } from '../features/application/reducers/business-info';
import { nextStep } from '../features/application/reducers/next-step';
import { updatePersonalAddress } from '../features/application/reducers/personalInfo';
import { RootState } from '../store';

export type AddressLookupType = 'none' | 'business' | 'personal' | 'shipping';
export const onCompleteAddressActionCreators: Record<AddressLookupType, (state: RootState) => Action> = {
  business: (state: RootState) => {
    const portalType = portalTypeSelector(state);
    return nextStep({
      action: 'collect_business_and_applicant_info',
      page: portalType == 'apply' ? 'business_info_2' : 'business_verify',
      gotoNextPage: true,
    });
  },
  personal: () =>
    nextStep({
      action: 'collect_business_and_applicant_info',
      page: 'personal_info',
      gotoNextPage: true,
    }),
  shipping: () =>
    nextStep({
      action: 'preview_card_order',
      gotoNextPage: true,
    }),
  none: () => {
    throw new Error();
  },
};

export const onUpdateAddressActionCreators: Record<AddressLookupType, (address: Address) => Action> = {
  business: updateBusinessAddress,
  personal: updatePersonalAddress,
  shipping: updateShippingAddress,
  none: () => {
    throw new Error();
  },
};
